export default {
  methods: {
    validate (e) {
      const isValid = this.$children
        .filter(c => (typeof c.validate !== 'undefined'))
        .map(c => c.validate())
        .every(res => res)

      if (!isValid) {
        e.preventDefault()
      }

      const invalidFields = this.$children.filter(c => {
        return typeof c.validate !== 'undefined' && !c.validate()
      })
      if (invalidFields.length) {
        invalidFields[0].$refs['input'].focus()
      }
    }
  }
}
